import React from 'react';
import dklogo from './img/dklogo.png';
import './redirectPages.css';

const NoPermissionsRedirect = () => {

	return (
		<div className="container container-no-access">
			<div className="no-access-body">
				<div className="message-box">
					<p>We're sorry, but you do not have the necessary permissions to access the Manhattan tool.</p>
					<p></p>
					<p>Please submit a ticket in <span className="ask-link"><a href="https://justaskdraftkings.freshservice.com/support/catalog/items/278">JustAsk</a></span> to request access to the <span className="ask-link">MP Manager</span> permission group, which will grant you access to the Manhattan tool.</p>
				</div>
				<div className="logo">
					<img src={dklogo} alt="DraftKings Logo" />
				</div>
			</div>
		</div>
	)
}

export default NoPermissionsRedirect;
